export default __webpack_public_path__ + "static/media/rio_verde.7bc262e4.mp4";